import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// IST Timezone formatting helpers
const IST_OPTIONS = { timeZone: 'Asia/Kolkata' };

export function formatDateIST(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-IN', { ...IST_OPTIONS, day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTimeIST(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleString('en-IN', { ...IST_OPTIONS, day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true });
}

export function formatTimeIST(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleTimeString('en-IN', { ...IST_OPTIONS, hour: '2-digit', minute: '2-digit', hour12: true });
}
